import { Phase, PhaseStrategy, privateApi } from 'services';
import { privateApiWithRouteLeavingCancelation } from '../ApiService/ApiServiceWithRouteLeavingCancelation';

const fetchBrandsAudiencePhaseStrategies = (brandsPhaseId: string): Promise<PhaseStrategy[]> =>
    privateApi.get<PhaseStrategy[]>(`brands-phases/${brandsPhaseId}/strategies`);

const postBrandsAudiencePhaseCampaign = (uuid: string, audience: string, phaseType: string): Promise<Phase> =>
    privateApi.post<Phase>(`brands-phases`, { uuid, audience, phaseType });

export const BrandsAudiencePhaseGateway = {
    fetchBrandsAudiencePhaseStrategies,
    postBrandsAudiencePhaseCampaign,
};

const cancelableFetchBrandsAudiencePhaseStrategies = (brandsPhaseId: string): Promise<PhaseStrategy[]> =>
    privateApiWithRouteLeavingCancelation.getWithAbortControl<PhaseStrategy[]>(
        `brands-phases/${brandsPhaseId}/strategies`,
    );

export const CancelableBrandsAudiencePhaseGateway = {
    cancelableFetchBrandsAudiencePhaseStrategies,
};
